export default __webpack_public_path__ + "static/media/404.25e44d01.gif";